/** 決済情報保存. */
export const SAVE_CREDIT_INFO = "SAVE_CREDIT_INFO";

/** 無料キャンペーン情報保存. */
export const SAVE_CAMPAIGN_INFO = "SAVE_CAMPAIGN_INFO";